import { BaseTypeaheadModal, MobileBaseTypeahead } from '../../../../backbone/shared/views/typeaheads';
import { ActiveLocationRecurringFormProjects } from '../collections';

const SelectActiveLocationRecurringFormProjectModal = BaseTypeaheadModal.extend({
    collection: new ActiveLocationRecurringFormProjects(),
    toolbarnav_title: function () {
        return _t('mobile_toolbarnav_title_select_project');
    },
    model: null, // ParentProject
    format_result: function (model) {
        return model.get('title');
    }
});

export const ActiveLocationRecurringFormProjectTypeahead = MobileBaseTypeahead.extend({
    model: null, // ParentProject
    modal_class: SelectActiveLocationRecurringFormProjectModal,
    i18n_key_placeholder: 'mobile_toolbarnav_title_select_project',

    get_default_value: function () {
        if (!this.model) {
            return '';
        }

        return this.model.get('title');
    }
});
